import React from 'react'
import { useState, useEffect } from "react"
import "./Karty_new.css";
import { object } from 'yup';
import Karty_new_form from './Karty_new_form';
import { MainNav, Nav, EditaceMenu, NapovedaSt} from '_components';

const Karty_new = () => {
    
    //console.log(childToChild);
   
    //<h4 className='lbl_Zarizeni_popis'>{childToChild.childToChild["z_ID"]} - {childToChild.childToChild["z_jmeno"]} - {childToChild.childToChild["z_par"]}</h4>
    return (
      <>
        <div className='body'>
            <Nav />
            <main>
            <MainNav></MainNav>
            
            <article>
            <h2 className='lblZarizeni_new'>Nový klíč</h2>
            <hr className="separator" />
            <Karty_new_form />  
            </article>
            
            </main>
            <footer>

            </footer>
        </div>
        
               
      </>
    )
}

export { Karty_new };